:host {
  display: flex;
  flex-direction: column;

  .rating-action {
    color: #666666;
    color: var(--font-secondary);
  }

  .rating-action {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    button {
      cursor: pointer;
      width: 100%;
      border: 1px solid #0098ff;
      background: white;
      background: var(--bg-primary);
      color: #0098ff;
      padding: 10px 20px;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      text-align: center;
      margin: 0 5px;
      border-radius: 6px;
      box-sizing: border-box;

      img {
        filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
          contrast(109%);
        filter: var(--icon-blue);
      }

      &:focus {
        outline: none;
      }

      &:hover {
        transition: all 0.3s;
        background: #0098ff;
        color: white;

        img {
          filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
            contrast(105%);
          filter: var(--icon-white);
        }
      }

      &:disabled {
        background: rgba(0, 0, 0, 0.12);
        background: var(--bg-disabled-button);
        border: none;
        color: rgba(0, 0, 0, 0.26);
        color: var(--font-disabled);
        cursor: not-allowed;

        img {
          filter: invert(73%) sepia(0%) saturate(68%) hue-rotate(243deg) brightness(97%)
            contrast(86%);
          filter: var(--icon-font-disabled);
        }
      }
    }

    &--negatif {
      img {
        transform: rotate(180deg);
      }
    }
  }

  .rating-reply {
    img {
      filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
        contrast(105%);
      filter: var(--icon-white);
    }
  }
}
